import React from 'react';
import '../blocks/ModernBlocks.css';

const TextImageRightBlock = ({ data }) => {
  return (
    <section className="text-image-right-section">
      <div className="text-image-right-container">
        {/* Separate full-width header section */}
        <div className="text-image-header">
          <h2 className="text-title">{data.title}</h2>
          <p className="text-subtitle">{data.subtitle}</p>
        </div>
        
        {/* Text and image layout */}
        <div className="text-image-right-content">
          <div className="text-image-right-text">
            <div className="text-content">
              <h3 className="content-heading">{data.content.heading}</h3>
              <p className="content-description">{data.content.description}</p>
              
              <div className="content-features">
                <h4>Key Features:</h4>
                <ul className="features-list">
                  {data.content.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span className="feature-text">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="content-button">
                <a href={data.content.button.link} className="cta-button primary">
                  {data.content.button.text}
                  <svg className="button-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          <div className="text-image-right-image">
            <img src={data.image} alt={data.title} />
            <div className="image-overlay">
              <div className="image-badge">
                <span className="badge-icon">🏠</span>
                <span className="badge-text">Smart Home</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextImageRightBlock; 